<template>
  <gg-card>
      <gg-card-header>
        Email Opt-in
      </gg-card-header>
      <gg-card-text>
        <p>
          GreenGeeks sends emails to you occasionally, manage what emails you would like to receive.
        </p>
        <v-switch
          label="Onboarding & Feedback"
          :loading="loading.onboarding"
          :input-value="SessionProfile.email_onboarding"
          hide-details
          @change="changeStatus('onboarding', SessionProfile.email_onboarding)"
        ></v-switch>
        <v-switch
          label="New Features & Company Related News"
          :loading="loading.news"
          :input-value="SessionProfile.email_news"
          hide-details
          @change="changeStatus('news', SessionProfile.email_news)"
        ></v-switch>
        <v-switch
          label="Promotional & Special Offers"
          :loading="loading.promotions"
          :input-value="SessionProfile.email_promotions"
          hide-details
          @change="changeStatus('promotions', SessionProfile.email_promotions)"
        ></v-switch>
        <v-switch
          label="Login Alerts"
          :loading="loading.loginalerts"
          :input-value="SessionProfile.email_loginalerts"
          hide-details
          @change="changeStatus('loginalerts', SessionProfile.email_loginalerts)"
        ></v-switch>
      </gg-card-text>
    </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { responseFailed, responseErrorMessage } from 'Helpers/helpers'

export default {
  name: 'PromotionalEmails',
  data: () => ({
    loading: {
      promotions: false,
      news: false,
      onboarding: false,
      loginalerts: false,
    }
  }),
  computed: mapGetters(['SessionProfile']),
  methods: {
    ...mapActions(['setEmailStatus', 'reportSuccess', 'reportError', 'getProfile']),
    async changeStatus (optType, currentVal) {
      if (!this.optionValid(optType)) {
        this.reportError('Invalid option!')
        return
      }
      this.loading[optType] = true
      try {
        const response = await this.setEmailStatus({ optType, status: !currentVal })
        if (!responseFailed(response)) {
          this.reportSuccess(response.resultmsg)
          this.getProfile()
        } else {
          this.reportError(responseErrorMessage(response))
        }
      } catch (e) {
        this.reportError(e)
      }
      this.loading[optType] = false
    },
    optionValid (opt) {
      return ['promotions', 'news', 'onboarding', 'loginalerts'].indexOf(opt) !== -1
    },
  },
}
</script>
